<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <!-- <li><a>{{company_name}}:</a></li> -->
    <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ul>
  <div class="right">
    <span>{{ today }}</span>
  </div>
</div>
<div class="tag_powered_by">
  <span>Powered by: <b>Enertics</b></span>
</div>
<div class="Content_outer">
  <div class="product_type">
    <button type="button" class="prod_btn" *ngIf="btnID_1 && rotatingAssetCount" [ngClass]="prodColor1" [disabled]="prodColor1 == 'active'" (click)="selectProductType('rotating')">Rotating Assets</button>
    <button type="button" class="prod_btn" *ngIf="btnID_4 && rotatingAssetCount" [ngClass]="prodColor2" [disabled]="prodColor2 == 'active'" (click)="selectProductType('transformer')">Transformer</button>
    <button type="button" class="prod_btn" *ngIf="btnID_3 && rotatingAssetCount" [ngClass]="prodColor3" [disabled]="prodColor3 == 'active'" (click)="selectProductType('emeter')">Energy Meters</button>
    <button type="button" class="prod_btn" *ngIf="btnID_2 && rotatingAssetCount" [ngClass]="prodColor4" [disabled]="prodColor4 == 'active'" (click)="selectProductType('eboiler')">Eboiler</button>
    <button type="button" class="prod_btn" *ngIf="btnID_7" [ngClass]="prodColor4" [disabled]="prodColor4 == 'active'" (click)="selectProductType('oven')">Oven</button>
  <mat-toolbar class="top_headerbar">
    <div class="right">
      <div class="all_action_btns">
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by Company Name"
            [(ngModel)]="termcompanyname"
            (input)="searchDatabycompanyname($event.target.value)"
          />
        </div>
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by Site Name"
            [(ngModel)]="site"
            (input)="searchDatabysite($event.target.value)"
          />
        </div>
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder="Search by Application"
            [(ngModel)]="application"
            (input)="searchDatabyApplication($event.target.value)"
          />
        </div>
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input
            type="text"
            class="form-control"
            placeholder=" Search by Asset Name"
            [(ngModel)]="assetname"
            (input)="searchDatabyassetname($event.target.value)"
          />
        </div>

        <div>
          <!-- <mat-form-field>
            <input matInput [matDatepicker]="startDatepicker" [formControl]="range.controls['start']" placeholder="Start Date">
            <mat-datepicker-toggle matSuffix [for]="startDatepicker" class="custom-datepicker-toggle"></mat-datepicker-toggle>
            <mat-datepicker #startDatepicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <input matInput [matDatepicker]="endDatepicker" [formControl]="range.controls['end']" placeholder="End Date">
            <mat-datepicker-toggle matSuffix [for]="endDatepicker" class="custom-datepicker-toggle"></mat-datepicker-toggle>
            <mat-datepicker #endDatepicker></mat-datepicker>
          </mat-form-field>           -->
          <mat-form-field>
            <div class="label">
              <mat-label></mat-label>
            </div>
            <div class="inside">
              <mat-date-range-input [rangePicker]="picker">
                <input
                  matStartDate
                  [formControl]="range.controls['start']"
                  placeholder="Start date"
                />
                <input
                  matEndDate
                  [formControl]="range.controls['end']"
                  placeholder="End date"
                />
              </mat-date-range-input>
            </div>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>

          <button
            class="primary_btn"
            mat-raised-button
            color="primary"
            class="custom_button"
             [disabled]="!(range.controls['start'].value || range.controls['end'].value)"
            (click)="onDateRangeChange(range.value.start, range.value.end)"
          >
            Apply Date Range
          </button>

          <button
            mat-raised-button
            class="custom_button active_clear"
            color="warn"
            [disabled]="
              !(
                termcompanyname != '' ||
                site != '' ||
                application != '' ||
                assetname != '' ||
                range.controls['start'].value ||
                range.controls['end'].value
              )
            "
            (click)="clearFilters()"
          >
            Clear Filters
          </button>
        </div>

        <div class="custom_search width_200">
          <mat-form-field appearance="fill">
          <mat-label>Select Report Type</mat-label>
          <mat-select [(ngModel)]="selectedReportType" (selectionChange)="filetype($event.value)">
            <mat-option value="all">All Reports</mat-option>
            <mat-option value="summary">Summary Reports</mat-option>
            <mat-option value="ondemand">SA On Demand Reports</mat-option>
            <mat-option value="anomaly">Anomaly Reports</mat-option>
            <mat-option value="periodic">Periodic Reports</mat-option>
          </mat-select>
        </mat-form-field>
        </div>
      </div>
    </div>
  </mat-toolbar>
  </div>
  <div class="no_result" *ngIf="showEmptyError !== ''">
    <p
      style="font-size: 16px; color: #838383; text-align: center; padding: 30px"
    >
      {{ showEmptyError }}
    </p>
  </div>
  <!-- <div class="no_result" *ngIf="!hasReports">
    <p
      style="font-size: 16px; color: #838383; text-align: center; padding: 30px"
    >
      There are no reports
    </p>
  </div> -->

  <!-- Rest of the template code as it is -->

  <div class="asset_list_view_outer">
    <div class="list_view_outer">
      <div class="table-responsive">
        <table class="table table-hover" *ngIf="showEmptyError == ''">
          <thead>
            <tr>
              <th>Company Name</th>
              <th>Site Name</th>
              <th>Application Name</th>
              <th>Asset Name</th>
              <th>Report Name</th>
              <th>Created Date / Time</th>
              <th></th>
              <th *ngIf="filet=='Report'"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let report of paginatedReportDataArr; let idx = index"
              [class.active]="idx == currentIndex"
            >
              <!-- <tr *ngFor="let report of reportDataArr| searchfilter: searchText;let idx = index; "> -->
              <td class="txt-color">{{ report?.company_name || "N/A" }}</td>
              <td>{{ report?.site_name || "N/A" }}</td>
              <td>{{ report?.application_name || "N/A" }}</td>
              <td>{{ report?.asset_name || "N/A" }}</td>
              <td>{{ report?.report_name || "N/A" }}</td>
              <td>{{ report?.created_at || "N/A" }}</td>
              <td class="text-center">
                <button
                mat-raised-button
                color="primary"
                (click)="viewReport(report.report_url)"
                >
                <span>View</span>
              </button>
            </td>
            <td class="text-center" *ngIf="(report?.report_name.startsWith('report') ||report?.report_name.startsWith('Subsystem')) && !Onprem ; else noreport">
              <button
              *ngIf="!paginatedReportDataArr[idx].loader; else loader"
              mat-raised-button
              color="accent"
              style="color: white !important"
                (click)="downloadReport(report.report_url,idx)"
              >
                <span>Download ⬇</span>
              </button>
              <!-- <a *ngIf="pdf_url !=''" (href)="pdf_url" download>Download Report</a> -->
            </td>
            <ng-template #loader>
              <!-- <ng-container>
                <div class="spinner-container charts-loader">
                  <div
                    class="spinner-border text-primary"
                    role="status"
                  ></div>
                </div>
              </ng-container> -->
              <button
                class="warning_btn"
                style="
                color: #fff !important;
                text-decoration: none;
                background-color: #14a44d;
                padding-left: 16px !important;
                padding-right: 16px !important;
                font-family: Roboto-Medium !important;
                font-size: 13px !important;
                transition: all .3s ease-in-out;
                line-height: normal !important;
                box-shadow: none !important;
                border-radius:4px;
                border:none;
                width: 100.18px !important;
                "
              >
              <div class="spinner-container charts-loader">
                <div
                  style="width: 1.3rem !important; height: 1.3rem !important; color:white !important;"
                  class="spinner-border"
                  role="status"
                ></div>
              </div>
              </button>
            </ng-template>

            <ng-template #noreport>
              <td></td>
            </ng-template>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <span *ngIf="hide">
    <div
      *ngIf="showNav === true && hasReports"
      class="d-flex justify-content-center"
    >
      <mat-paginator
        [length]="count"
        [pageSize]="tableSize"
        [pageIndex]="page - 1"
        [pageSizeOptions]="[10]"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </span>
</div>
